import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ArchiveTitleSectionSection from "./sections/ArchiveTitleSectionSection"
import CatalogSearch from "./sections/CatalogSearch"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <ArchiveTitleSectionSection />
      <CatalogSearch />
      <Footer />
    </div>
  )
}
